/* @flow */

import { normalizeLocations } from '@braindate/domain/lib/location/util';

import * as types from './locationActionTypes';
import { patchEntities } from 'src/shared/domain/base/action/entityActions';
import { locationsEndpoint } from 'src/shared/app/base/settings/endpointSettings';
import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';
import type { GetState } from 'src/shared/core/type/reduxTypes';

export function fetchLocations(id: number | string, data?: Object) {
  return (dispatch: any, _: GetState, { get }: Object) => {
    dispatch(fetchLocationsRequest());

    return get(locationsEndpoint(id), data)
      .then(parseResponse)
      .then((json) => {
        const normalizedData = normalizeLocations(json);
        const { entities, result } = normalizedData;
        dispatch(patchEntities(entities));
        // $FlowIssue
        dispatch(fetchLocationsSuccess(result));

        return json;
      })
      .catch((exception) => {
        dispatch(fetchLocationsFailure(exception));

        throw exception;
      });
  };
}

export function fetchLocationsRequest() {
  return {
    type: types.FETCH_LOCATIONS_REQUEST,
  };
}

export function fetchLocationsSuccess(result: number) {
  return {
    type: types.FETCH_LOCATIONS_SUCCESS,
    result,
  };
}

export function fetchLocationsFailure(exception: Error) {
  return {
    type: types.FETCH_LOCATIONS_FAILURE,
    exception,
  };
}
